<template>
	<div class="">
        <div class="row" v-show="tickets.length">
            <div class="col-md-6">
                Encontrados {{ tickets.length }} tickets
            </div>
            <div class="col-md-6 text-right">
                <input id="responsaveisApenasComTicket" type="checkbox" v-model="responsaveisApenasComTicket" />
                <label for="responsaveisApenasComTicket"> Mostrar responsáveis apenas com tickets atribuidos </label>
            </div>
        </div>
        <div class="col-md-12" v-if="!tickets.length">
            <br>
            <p>
                Nenhum ticket encontrado.
            </p>
        </div>
		<div class="board__container" v-else>
            <div class="board__columns-container">
                <div
                    v-for="responsavel in responsaveis"
                    :key="responsavel.key"
                    :title="responsavel.title"
                    v-show="!responsaveisApenasComTicket || filtrarTicketsPorUsuario(responsavel.id).length"
                    class="board__column"
                >
                    <div class="card text-center">
                        <div class="card-body board__ticket-container">
                            <div class="text-left card-title board__ticket-header">
                                <h5 class=" text-info">
                                    <fa-icon :icon="responsavel.nome ? 'user' : 'map-pin'"/>
                                    {{ responsavel.nome || 'Pendente (Sem responsável)'}}
                                    <small>
                                        ({{filtrarTicketsPorUsuario(responsavel.id).length}} tickets)
                                    </small>
                                </h5>
                            </div>
                            <div
                                v-for="ticket in filtrarTicketsPorUsuario(responsavel.id)"
                                :key="ticket.key"
                                :title="ticket.title"
                                class="card text-center"
                                style="margin-bottom: 10px;"
                            >
                                <div
                                    class="card-body board__ticket"
                                    @click="clickEditar(ticket)"
                                    title="Editar ticket">
                                    <div class="text-left">
										<div style="margin-bottom: 5px;">
											<span class="badge" :class="getClasseBadgePrioridade(ticket.prioridade)">
                                            	{{ ticket.prioridade }}
                                        	</span>
											<span class="badge" :class="getLabelStatus(ticket.status).classeLabel">
                                            	{{ getLabelStatus(ticket.status).label }}
                                        	</span>
											<span v-if="ticket.desenvolvimentoConcluido" class="badge" :class="ticket.desenvolvimentoConcluido ? 'badge-secondary' : ''">
                                            	DEV CONCLUÍDO
                                        	</span>
										</div>
                                        <span>
                                            <b>Código:</b>
                                            {{ ticket.codigo }}
                                            <br />
                                        </span>
                                        <span>
                                            <b>Cliente:</b>
                                            {{ ticket.nomeCliente }}
                                            <br />
                                        </span>
                                        <span>
                                            <b>Abertura:</b>
                                            {{ ticket._dataAbertura }}
                                            <br />
                                        </span>
                                        <span class="pull-right">
                                            <b>Usuário:</b>
                                            {{ ticket.nomeUsuario }}
                                            <br />
                                        </span>
                                        <span class="pull-right">
                                            <b>Título:</b>
                                            {{ ticket.titulo }}
                                            <br />
                                        </span>

                                        <!-- <button class="col-md-12 btn btn-outline-link btn-link " @click="clickEditar(ticket)">
                                            <icon-circular-details/>
                                        </button> -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>
<script>
import iconCircularDetails from '../../../components/icons/icon-circular-details.vue'
export default {
    components: {
        iconCircularDetails
    },
    data() {
        return {
            responsaveisApenasComTicket: true
        }
    },
    props: {
        responsaveis: {
            type: Array,
            default: () => [],
            require: true,
        },
        tickets: {
            type: Array,
            default: () => [],
            require: true,
        }
    },
    methods: {
        filtrarTicketsPorUsuario(idUsuarioResponsavel) {
            return this.tickets.filter((ticket) => ticket.idUsuarioResponsavel === idUsuarioResponsavel)
        },
        getClasseBadgePrioridade(prioridade) {
            let classe = ''
            switch (prioridade) {
                case 'BAIXA':
                    classe = 'badge-success'
                    break;

                case 'MÉDIA':
                    classe = 'badge-warning'
                    break;

                default:
                    classe = 'badge-danger'
                    break;
            }
            return classe
		},
		getLabelStatus(status) {
			let dadosStatus = {
				label: '',
				classeLabel: ''
			}

            switch (status) {
                case 'A':
					dadosStatus = {
						label: 'ABERTO',
						classeLabel: 'badge-primary'
					}
                    break;

                case 'E':
					dadosStatus = {
						label: 'EM ANDAMENTO',
						classeLabel: 'badge-info'
					}
                    break;

				case 'O':
					dadosStatus = {
						label: 'CONCLUÍDO',
						classeLabel: 'badge-success'
					}
                    break;

                default:
					dadosStatus = {
						label: 'CANCELADO',
						classeLabel: 'badge-danger'
					}
                    break;
            }
            return dadosStatus
        },
        clickEditar(ticket) {
            this.$emit('click-editar', { _object: ticket })
        }
    },
}
</script>
<style lang="css" scoped>
    .board__container {
        /* max-width: 82vw; */
        position: absolute;
        max-width: calc(100% - 260px);
        overflow-x: scroll;
        max-height: 73vh;
    }
    .board__columns-container {
        display: grid;
        grid-template-rows: 1fr;
        grid-template-columns: repeat(20, 21rem);
        gap: .8rem;
    }
    .board__column {
        border: 1px solid #d7d7d7;
        border-radius: 5px;
        height: fit-content;
    }
    .board__column, .board__ticket {
        box-shadow: 1px 2px 1px rgba(9,30,66,.25);
    }
    .btn-outline-link {
        border: 1px solid #007bff;
    }
    .board__ticket {
        border: 0;
        border-radius: 12px;
        cursor: pointer;
        background-color: #e8e8e875;
        margin: 0 .7rem;
    }
    .board__ticket-container {
        max-height: 70vh;
        overflow-y: scroll;
        padding: 0;
    }
    .board__ticket-header {
        position: sticky;
        top: 0;
        z-index: 100;
        background: white;
        padding: 1rem 1.2rem .5rem;
        margin-bottom: 0;
    }
    .card {
        border: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/ticket/geral/designado.vue